// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCloud } from '@ni/nimble-components/dist/esm/icons/cloud';
import { wrap } from '../utilities/react-wrapper';

export { type IconCloud };
export const NimbleIconCloud = wrap(IconCloud);